import fetchBlogPosts from './fetchBlogPosts';
import extractBlogPost from './extractBlogPost';

/**
 * See fetchBlogPosts for breakdown of options
 */
async function fetchLatestBlogPosts(options) {
    const response = await fetchBlogPosts({
        ...options,
        locale: options.locale,
    });

    return {
        ...response,
        posts: response.posts.map(post => extractBlogPost(post, options)),
    };
}

export default fetchLatestBlogPosts;
